import React from 'react';
import styles from './ListGroup.module.css';

export default function ListGroup({ children, className = '', ...rest }) {
  return (
    <ul className={`${styles.list} ${className}`} {...rest}>
      {children}
    </ul>
  );
}

ListGroup.Item = function ListItem({ children, active = false, disabled = false, onClick, className = '', action = false, ...rest }) {
  const Component = action ? (onClick ? 'button' : 'a') : 'li';
  return (
    <Component
      className={`${styles.item} ${active ? styles.active : ''} ${disabled ? styles.disabled : ''} ${action ? styles.action : ''} ${className}`}
      onClick={disabled ? undefined : onClick}
      disabled={disabled}
      {...rest}
    >
      {children}
    </Component>
  );
};
